import { API_URL } from '../config/config';
import { getRequest } from '../utils/axiosUtils';
import buildQueryParams from '../utils/buildQueryParams';

/**
 * Member Engagement & Response Tracker data.
 *
 * Returns { now, members } where `members` is the subscribed population (same
 * source as the Subscribed User List) with their outbound conversation threads.
 * The page derives response-rate / latency / status from the raw threads, so
 * `now` is the server snapshot used for the waiting-time math.
 */
export const getMemberEngagement = async (filter = {}) => {
  const { country, state, city, gender, searchTerm, userId } = filter;

  let queryParams = buildQueryParams({ country, state, city, gender, searchTerm });
  // `userId` scopes the response to a single subscriber (used by the Subscription
  // Report drawer, which reuses this same engagement UI for one member). It is
  // appended directly because buildQueryParams only forwards its whitelisted keys.
  if (userId) {
    queryParams += `${queryParams ? '&' : ''}userId=${encodeURIComponent(userId)}`;
  }

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getMemberEngagement${queryParams ? `?${queryParams}` : ''}`,
    isAbort: false,
  });
  if (!res) return null;
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  }
  throw new Error(`Unexpected response code: ${res.status}`);
};
